export const inviteLinkRoot = `${window.location.protocol}//${window.location.host}`; // process.env.NODE_ENV === 'development' ? ROOTS.DEV : ROOTS.PROD;
